<div class="location-manager">
  <mat-card class="search-card">
    <h1 class="title">{{ title }}</h1>
    <app-generic-search
      [label]="'Search locations'"
      [placeholder]="'Find by address or name'"
      [searchString]="searchString$ | async"
      [focus]="true"
      (search)="handleSearch($event)"
      (clearSearch)="handleClearSearch()"
    ></app-generic-search>
    <mat-divider *ngIf="(autoCompleteResults$ | async)[0] && !(loadedLocation$ | async)"></mat-divider>
    <app-generic-autocomplete-results
      [autocompleteResults]="autoCompleteResults$ | async"
      [displayedFields]="[[['label']]]"
      (resultSelected)="handleAutocompleteResultSelected($event)"
      [testingIdAccessor]="'label'"
    ></app-generic-autocomplete-results>
    <app-location
      *ngIf="loadedLocation$ | async"
      [loadedLocation]="loadedLocation$ | async"
      [mapLoaded]="mapLoaded$ | async"
      [selectedLocation]="selectedLocation$ | async"
      [hoveredLocation]="hoveredLocation$ | async"
      [addingNewLocation]="addingNewLocation$ | async"
      [newLocationName]="newLocationName$ | async"
      [offsetLocationMode]="offsetLocationMode$ | async"
      [mapCenterCoords]="mapCenter$ | async"
      [geocodedOffsetLocation]="geocodedOffsetLocation$ | async"
      (locationMouseover)="handleLocationMouseover($event)"
      (locationMouseout)="handleLocationMouseout($event)"
      (selectLocation)="handleSelectLocation($event)"
      (addNewLocation)="handleAddNewLocation()"
      (cancelNewLocation)="handleCancelAddNewLocation()"
      (saveNewLocation)="handleSaveNewLocation($event)"
      (deleteSublocation)="handleDeleteSublocation($event)"
    ></app-location>
    <mat-card-actions align="end" *ngIf="!(addingNewLocation$ | async) && !managing">
      <button
        id="locationManager-button-cancel"
        *ngIf="!managing && !(addingNewLocation$ | async)"
        mat-stroked-button
        color="primary"
        (click)="cancel.emit()"
      >
        Cancel
      </button>
      &nbsp;&nbsp;
      <button
        id="locationManager-button-useLocation"
        *ngIf="!managing"
        mat-raised-button
        [disabled]="loading || (!((selectedLocation$ | async) || (offsetLocationMode$ | async)) && !(addingNewLocation$ | async))"
        color="primary"
        (click)="handleUseLocation()"
      >
        Confirm location
        <mat-progress-spinner *ngIf="loading" [mode]="'indeterminate'" [diameter]="20" [strokeWidth]="2"></mat-progress-spinner>
      </button>
    </mat-card-actions>
  </mat-card>
  <mat-card appearance="outlined" class="map-card">
    <app-location-manager-map
      [managing]="managing"
      [mapCenterCoords]="mapCenter$ | async"
      [userLocation]="userLocation$ | async"
      [offsetLocationMode]="offsetLocationMode$ | async"
      [loadedLocation]="loadedLocation$ | async"
      [hoveredLocation]="hoveredLocation$ | async"
      [selectedLocation]="selectedLocation$ | async"
      [addingNewLocation]="addingNewLocation$ | async"
      (mapMoved)="handleMapMoved($event)"
      (mapLoaded)="handleMapLoaded()"
      (useOffsetLocation)="handleOffsetLocationMode($event)"
    ></app-location-manager-map>
  </mat-card>
</div>
